<template>
  <div
    ref="root"
    class="flex flex-col justify-start overflow-hidden"
    :class="hasMounted ? '' : 'h-0'"
  >
    <div ref="inner" class="w-full">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface BaseExpandingWrapperProps {
  fade?: boolean
  open?: boolean
}

const props = withDefaults(defineProps<BaseExpandingWrapperProps>(), {
  fade: false,
  open: false,
})
const root = ref<HTMLDivElement | null>(null)
const inner = ref<HTMLDivElement | null>(null)
const hasMounted = ref(false)

const { $anime } = useNuxtApp()
const emit = defineEmits(['close'])

onMounted(() => {
  if (!props.open && root.value) {
    $anime.set(root.value, { height: 0 })
  }

  hasMounted.value = true

  watch(props, ({ open }) => {
    if (root.value && inner.value) {
      const height = parseInt(`${$anime.get(inner.value, 'height')}`, 10)
      const duration = Math.max(500, height * 1.25)

      const options = {
        targets: root.value,
        height: open ? [0, height] : 0,
        opacity: {},
        translateZ: 0,
        duration,
        easing: slideEasing,
        complete() {
          if (open) {
            root.value!.style.height = ''
          } else {
            emit('close')
          }
        },
      }

      if (props.fade) {
        options.opacity = {
          value: open ? [0, 1] : 0,
          delay: open ? duration * 0.3 : 0,
        }
      }

      $anime(options)
    }
  })
})
</script>
